import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Svg,
} from '@react-pdf/renderer';
import logo from '../../../assets/Logo_mit_Name.png';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  logo: {
    width: 150,
    height: 'auto',
    marginBottom: 50,
    alignSelf: 'center',
  },
  header: {
    fontSize: 18,
    marginBottom: 20,
  },
  section: {
    marginBottom: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    marginVertical: 15,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '25%',
    borderBottom: '1 solid black',
    paddingBottom: 5,
  },
  tableCol: {
    width: '25%',
  },
  tableCellHeader: {
    fontWeight: 'bold',
  },
  tableCell: {
    margin: '5 0',
  },
  totals: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  totalLabel: {
    width: '70%',
    textAlign: 'right',
    paddingRight: 10,
  },
  totalValue: {
    width: '30%',
    textAlign: 'right',
  },
});

const Invoice = ({ order }) => {
  const {
    _id,
    orderItems,
    address,
    total,
    subtotal,
    tax,
    shippingFee,
    createdAt,
    orderNumber,
  } = order;

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE');
  };

  // Format price
  const formatPrice = (price) => `${(price / 100).toFixed(2)} CHF`;

  // Company information
  const companyInfo = {
    name: 'sVisit Koller',
    address: 'Felsenstrasse 71',
    zip: '9000',
    city: 'St. Gallen',
    country: 'Schweiz',
    email: 'info@svisit.ch',
    cheId: 'CHE-302.293.317',
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Company Logo */}
        <Image style={styles.logo} src={logo} />

        {/* Company Information */}
        <View style={styles.section}>
          <Text>{companyInfo.name}</Text>
          <Text>{companyInfo.address}</Text>
          <Text>
            {companyInfo.zip} {companyInfo.city}
          </Text>
          <Text>{companyInfo.country}</Text>
          <Text>E-Mail: {companyInfo.email}</Text>
          <Text>Firmennummer: {companyInfo.cheId}</Text>
        </View>

        {/* Invoice Header */}
        <Text style={styles.header}>Rechnung</Text>

        {/* Invoice Details */}
        <View style={styles.section}>
          <Text>Rechnungsnummer: {orderNumber || _id}</Text>
          <Text>Datum: {formatDate(createdAt)}</Text>
        </View>

        {/* Customer Address */}
        <View style={styles.section}>
          <Text>Kundendaten:</Text>
          <Text>
            {address[0].firstName} {address[0].lastName}
          </Text>
          {address[0].company && <Text>{address[0].company}</Text>}
          <Text>{address[0].address}</Text>
          <Text>
            {address[0].zip} {address[0].city}
          </Text>
          <Text>{address[0].country}</Text>
          <Text>Telefon: {address[0].phone}</Text>
        </View>

        {/* Order Items Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Artikel</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Menge</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Einzelpreis</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Gesamtpreis</Text>
            </View>
          </View>
          {/* Table Rows */}
          {orderItems.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.name}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.amount}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{formatPrice(item.price)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {formatPrice(item.price * item.amount)}
                </Text>
              </View>
            </View>
          ))}
        </View>

        {/* Totals */}
        <View style={styles.totals}>
          <Text style={styles.totalLabel}>Zwischensumme:</Text>
          <Text style={styles.totalValue}>{formatPrice(subtotal)}</Text>
        </View>
        <View style={styles.totals}>
          <Text style={styles.totalLabel}>Versandkosten:</Text>
          <Text style={styles.totalValue}>{formatPrice(shippingFee)}</Text>
        </View>
        <View style={styles.totals}>
          <Text style={styles.totalLabel}>Enthaltene MwSt 8.1%:</Text>
          <Text style={styles.totalValue}>{formatPrice(tax)}</Text>
        </View>
        <View style={styles.totals}>
          <Text style={styles.totalLabel}>Gesamtsumme:</Text>
          <Text style={styles.totalValue}>{formatPrice(total)}</Text>
        </View>

        {/* Footer */}
        <View style={styles.section}>
          <Text>Vielen Dank für Ihren Einkauf!</Text>
        </View>
      </Page>
    </Document>
  );
};

export default Invoice;
